// extracted by mini-css-extract-plugin
export default {"edit":"EditForm_edit__CMC6X","inner":"EditForm_inner__ZuVkP"};